import React from "react";

export default function AccountantComponent() {
  return (
    <div
      className="main_contact_area app pt-40 bg_fixed"
      
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side Image */}
          <div class="col-lg-7 pb-40">  
          <div className="section_main_title black text-left">
                <h5>Key Responsibilities</h5>
          </div>       
            <div class="why-choose-icon " data-wow-delay=".5">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Handle GST compliances, GST returns, Income Tax & Service Tax cases.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Filling of returns - TDS returns, GST returns and Professional tax return.</h6>
              </div>
              
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Review of collection and vendor payments & cash management.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Assisting in scrutiny of trial balance and ledger accounts.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Assisting in finalization of balance sheet, co-ordinate with internal & statutory auditors.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>MIS, annual budgeting & quarterly reporting.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Handling daily data entry for purchases, sales, cash, bank, and journal vouchers.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Scrutiny of debtor, creditor ledgers.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Preparation of accounts payable and accounts receivable statements.</h6>
              </div>
             
            </div>
            <div className="section_main_title black text-left mt-3">
                <h5>Sillset Required</h5>
            </div> 
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Bachelor’s degree in accounting, Finance, or related field.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>CPA or equivalent certification preferred.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Minimum of 1-2 years of accounting experience.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Proficiency in accounting software (e.g., Tally, SAP, Oracle).</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Strong knowledge of accounting principles and regulations.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Excellent analytical and problem-solving skills.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Strong attention to detail and accuracy.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Proficient in Microsoft Office Suite, particularly Excel.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Excellent communication and interpersonal skills.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Ability to work independently and as part of a team.</h6>
              </div>
             
            </div>
         
     
 
</div>


          {/* Right Side Contact Form */}
          <div className="col-lg-5">
            <div className="section_title black mb-4">
             
              <div className="section_main_title">
                <h1>Apply Now</h1>
              </div>
            </div>

            
            <iframe
              id="if15on87"
              src="https://formnx.com/f/career-15on87?iframe=true"
              frameBorder="0"
              style={{ width: '1px', minWidth: '100%', height: '700px' }}
              title="Career Form"
            />
            <script src="https://formnx.com/js/iframeResizer.js"></script>
            <script src="https://formnx.com/js/widget.js"></script>
          </div>
        </div>
      </div>
    </div>
  );
}
